import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  authenticate(user_id, password) {
    return RequesterV1.post("security/authenticate", {
      user_id: user_id,
      password: password
    });
  },
  logout() {
    return RequesterV1.get("security/logout");
  }
};
